import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Box, IconButton, Typography } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import TkBasicHeader from "../BasicHeader";
import { TkHeaderProps } from "../../../../../../type/componentsType/TkHeaderType";
import "../BasicHeader/_style.scss";
import { GlobalContext } from "../../../../../../context/globalContext";
import { BusinessContext } from "../../../../../../context/businessContext";
import TkMenuForDaikou from "../../../../TkMenuForDaikou";
import TkQaButton from "../../QaButton";
/**
 * ヘッダー部品（代行）
 * ユーザータイプが代行者の場合のページのヘッダー
 * @param props ヘッダーのプロパティ
 * @param props.headerName ヘッダーの名前
 * @param props.hideButton ボタンを非表示にするかどうか
 * @return TkHeader ヘッダー部品（法人、法人代行者）
 */
export const TkDaikouHeader: React.FC<TkHeaderProps> = (props) => {
  const { headerName } = props;
  const navigate = useNavigate();
  const { setState } = useContext(GlobalContext);
  const { setState: setBusinessStete } = useContext(BusinessContext);

  return (
    <Box data-testid="tkDaikouHeader">
      <TkBasicHeader>
        <TkBasicHeader.Slot slot="left">
          <TkMenuForDaikou />
        </TkBasicHeader.Slot>

        <TkBasicHeader.Slot slot="right">
          <Typography className="tkUserName">{headerName}　様</Typography>
          <TkQaButton />
          <IconButton
            onClick={() => {
              setState({});
              setBusinessStete({});
              navigate("/");
            }}
            data-testid="logoutIcon"
          >
            <LogoutIcon />
          </IconButton>
        </TkBasicHeader.Slot>
      </TkBasicHeader>
    </Box>
  );
};

export default TkDaikouHeader;
